import { Icon, Tooltip, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

import { createArrayWithBooleans } from '../../../NewApplication/Product/components/Funds/constants';

interface RiskRatingTooltipProps {
  label?: string | null;
  value?: number;
}

export const RiskRatingTooltip: React.FC<RiskRatingTooltipProps> = ({ label, value }) => {
  return (
    <Tooltip testID="qa" label={label || ''}>
      <HStack space={Spacing['inline.nano']}>
        {createArrayWithBooleans(value || 0)?.map((ristRatingLevel, index) => (
          <Icon
            key={index.toString()}
            testID="qa"
            name="Circle"
            size="xxxxxs"
            color={Color[ristRatingLevel ? 'neutral.darkest' : 'neutral.lightest']}
          />
        ))}
      </HStack>
    </Tooltip>
  );
};
